/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { navigateTo } from '../../../../actions/navigationActions';
import { DASHBOARD } from '../../../../routes/routes';
import '../../FNOL.css'
import './WarrantyClaimEnd.css'

class WarrantyClaimEnd extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.state = {
            claimStatus: "submitted",
        };
        this.handleViewClaim = this.handleViewClaim.bind(this);
        this.handleToggleSubmitted = this.handleToggleSubmitted.bind(this);
        this.handleToggleAuthorised = this.handleToggleAuthorised.bind(this);
        this.handleToggleNotAuthorised = this.handleToggleNotAuthorised.bind(this);
    }

    async handleViewClaim() {
        this.props.redirectTo(DASHBOARD);
    }

    async handleToggleSubmitted() {
        this.setState({ claimStatus: "submitted" });
    }

    async handleToggleAuthorised() {
        this.setState({ claimStatus: "authorised" });
    }

    async handleToggleNotAuthorised() {
        this.setState({ claimStatus: "notauthorised" });
    }

    componentDidMount() {
        if (this.props.claimSubmit.claimStatus === 1) {
            this.setState({ claimStatus: "submitted" });
        }
        else if (this.props.claimSubmit.claimStatus === 4) {
            this.setState({ claimStatus: "authorised" });
        }
        else {
            this.setState({ claimStatus: "notauthorised" });
        }
        window.scrollTo(0, 0);
    }

    public render() {
        return (
            <div className="col content-box-padding-20px-bottom-40px">
                <div className="row noma">
                    <div className="col-12 nopa mb-10px ml-10px">
                        <div className="row noma">
                            <div className="fnol-step-header-icon-area">
                                <img src='/my-policy/Images/icon-checkmark-nugreen-32px-32px.svg' alt="Claims Complete" title="Claims Complete" />
                            </div>
                            <div className="col fnol-step-header-title-area claim-info-header">
                                <h3 className="text-green">Claim info = sent to GRSA</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row noma  mb-30px">
                    <div className="col-12 mobile-center fnol-steps-info-section-holder glass-claim-info-holder">
                        <hr className="hr-minus21px" />
                        <div className="">
                            <div className="mb-10px text-left">
                                <p className="line-height-normal">Thanks for telling us about your claim. Our partner, GRSA, will take it from here. 1 of their claims consultants will contact you within 4 business hours (Mondays to Fridays, 08:00 - 16:30) to register your claim, so listen out for their call.<br /><br />
                                    If you have queries or you want to follow up on your claim, you can contact GRSA on <b>010 001 0012</b>.</p>
                            </div>
                        </div>

                        <div className="nopa fnol-steps-buttonholder mt-40px">
                            <button className="btn btn-outline-red button-width" onClick={this.handleViewClaim}>Back to dashboard</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WarrantyClaimEnd)
